export default {
  inputHeight: 50,
  dragHandleWidth: 44,
  containerPaddingBreakpoint: 24,
  containerPaddingBelowBreakpoint: 16,
};
